<template>
  
    <div class="admin-layout">
    <!-- Sidebar affichée -->
    <SidebarAdmin />  
    <!-- Contenu principal -->
  <div class="dashboard-admin">
    <h2>Tableau de bord général</h2>

    <!-- === NOTIFICATIONS === -->
<div class="notification-section">
  <h3>🔔 Notifications récentes</h3>

  <div v-if="notifications.length === 0" class="empty-msg">
    Aucune nouvelle notification pour le moment.
  </div>

  <ul v-else>
    <li v-for="(notif, i) in notifications" :key="i" class="notif-item">
      <span class="notif-time">{{ formatDate(notif.date) }}</span>  
      <span class="notif-text">{{ notif.message }}</span>
    </li>
  </ul>
</div>
    <!-- Statistiques -->
    <div class="stats-grid">
      <div class="card stat-card">
        <h3>👤 Clients</h3>
        <p>{{ clientsCount }}</p>
      </div>
      <div class="card stat-card">
        <h3>📦 Commandes</h3>
        <p>{{ ordersCount }}</p>
      </div>
      <div class="card stat-card">
        <h3>🚚 En attente</h3>
        <p>{{ pendingCount }}</p>
      </div>
      <div class="card stat-card">
        <h3>💰 Total ventes</h3>
        <p>{{ totalSales.toFixed(2) }} MAD</p>
      </div>
    </div>

    <!-- Graphiques -->
    <AdminChart />
    <AdminBarChart />

    <!-- Activités récentes -->
    <div class="recent-section">
      <h3>🕓 Activités récentes</h3>
      <ul>
        <li v-for="(order, i) in recentOrders" :key="i">
          <span>{{ formatDate(order.createdAt) }}</span> — 
          {{ order.user?.prenom }} {{ order.user?.nom }} a passé une commande ({{ order.status }})
        </li>
      </ul>
    </div>
<!-- === GRAPHIQUE DES VENTES === -->
<div class="chart-section">
  <h3>📊 Évolution des ventes mensuelles</h3>
  <canvas id="salesChart"></canvas>
</div>

<!-- === TOAST NOTIFICATIONS === -->
<div class="toast-container">
  <transition-group name="toast" tag="div">
    <div
      v-for="(toast, index) in toastNotifications"
      :key="index"
      class="toast"
      :class="toast.type"
    >
      <span class="icon">🔔</span>
      <div class="toast-content">
        <p class="toast-message">{{ toast.message }}</p>
        <small>{{ formatDate(toast.date) }}</small>
      </div>
    </div>
  </transition-group>
</div>

    </div>
  </div>
  
</template>

<script>
import axios from "axios";
import { Chart, registerables } from "chart.js";
import { io } from "socket.io-client";
//import AdminChart from "@/components/admin/AdminChart.vue";
//import AdminBarChart from "@/components/admin/AdminBarChart.vue";
import SidebarAdmin from "@/views/admin/SidebarAdmin.vue";
Chart.register(...registerables);
export default {
  name: "DashboardAdmin",
  components: { SidebarAdmin },
  //components: { AdminChart, AdminBarChart },
  data() {
    return {
      clientsCount: 0,
      ordersCount: 0,
      pendingCount: 0,
      totalSales: 0,
      recentOrders: [],
      monthlySales: [],
      notifications: [],
      toastNotifications: [], //pour les toasts
      audio: null, // pour le son
    };
  },
async mounted() {
   this.audio = new Audio("/public/sounds/mixkit-bell-notification-933.wav");
  this.connectSocket(); // écoute temps réel
  this.loadStats();  
 /* try {
    const res = await axios.get("http://localhost:2028/api/orders/stats");

    this.clientsCount = res.data.clientsCount;
    this.ordersCount = res.data.ordersCount;
    this.pendingCount = res.data.pendingCount;
    this.totalSales = res.data.totalSales;
    this.recentOrders = res.data.recentOrders;
    this.monthlySales = res.data.monthlySales;

        //Notifications simulées (tu pourras remplacer plus tard par un vrai backend)
    this.notifications = [
      { message: "Nouvelle commande passée par un client", date: new Date() },
      { message: "Un client s'est inscrit sur la plateforme", date: new Date(Date.now() - 3600000) },
      { message: "Une commande a été confirmée", date: new Date(Date.now() - 7200000) },
    ];
      // Calculer les ventes mensuelles
      this.monthlySales = this.calculateMonthlySales(res.data.recentOrders);

      // Afficher le graphique
      this.renderChart();

    console.log("📊 Stats reçues :", res.data);
  } catch (err) {
    console.error("Erreur chargement stats admin:", err);
  }*/
},

 methods: {

  async loadStats() {
    try {
      const res = await axios.get("http://localhost:2028/api/orders/stats");
      this.clientsCount = res.data.clientsCount;
      this.ordersCount = res.data.ordersCount;
      this.pendingCount = res.data.pendingCount;
      this.totalSales = res.data.totalSales;
      this.recentOrders = res.data.recentOrders;
      this.monthlySales = this.calculateMonthlySales(res.data.recentOrders);
      this.renderChart();
    } catch (err) {
      console.error("Erreur chargement stats admin:", err);
    }
  },

 connectSocket() {
      const socket = io("http://localhost:2028");
      socket.on("new-notification", (notif) => {
        this.notifications.unshift(notif);
        this.showToast(notif.message, notif.type || "info");
      });
    },

    //  Fonction toast
    showToast(message, type = "info") {
      const toast = {
        message,
        type,
        date: new Date(),
      };

      this.toastNotifications.unshift(toast);
      this.audio?.play(); // 🔊 joue un son de notification

      // Supprimer le toast après 4s
      setTimeout(() => {
        this.toastNotifications.pop();
      }, 4000);
    },


   /* socket.on("disconnect", () => {
      console.log("Déconnecté du serveur Socket.IO");
    });*/
  
    formatDate(date) {
      return new Date(date).toLocaleString("fr-FR");
    },
    calculateMonthlySales(orders) {
      const months = [
        "Jan", "Fév", "Mar", "Avr", "Mai", "Juin",
        "Juil", "Août", "Sep", "Oct", "Nov", "Déc"
      ];

      const monthly = new Array(12).fill(0);
      orders.forEach(o => {
        if (o.createdAt && o.total) {
          const month = new Date(o.createdAt).getMonth();
          monthly[month] += o.total;
        }
      });

      return { labels: months, data: monthly };
    },
    renderChart() {
      const ctx = document.getElementById("salesChart");
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.monthlySales.labels,
          datasets: [
            {
              label: "Total ventes (MAD)",
              data: this.monthlySales.data,
              backgroundColor: "rgba(0, 153, 139, 0.6)",
              borderColor: "#00998b",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            y: { beginAtZero: true },
          },
          plugins: {
            legend: { display: true, position: "top" },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
/* --- LAYOUT --- */
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f4f6f9;
  font-family: "Poppins", sans-serif;

}

.dashboard-admin {
  flex: 1;
  padding: 40px;
  color: #222;
  overflow-y: auto;
}

/* --- HEADER --- */
.dashboard-header {
  margin-bottom: 30px;
}
.dashboard-header h2 {
  color: #05305b;
  font-size: 26px;
  margin-bottom: 5px;
}
.dashboard-header .subtitle {
  font-size: 15px;
  color: #777;
}

/* --- STATISTIQUES --- */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}
.stat-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.stat-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}
.stat-card .icon {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
}
.bg-blue { background-color: #00998B; }
.bg-green { background-color: #28a745; }
.bg-orange { background-color: #ff9800; }
.bg-purple { background-color: #6f42c1; }

.stat-card .info h3 {
  font-size: 15px;
  color: #555;
}
.stat-card .info p {
  font-size: 24px;
  color: #05305b;
  font-weight: 700;
  margin-top: 5px;
}

/* --- ACTIVITÉS RÉCENTES --- */
.recent-section {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
}
.recent-section h3 {
  margin-bottom: 15px;
  color: #00998B;
  font-size: 18px;
  font-weight: 600;
}
.recent-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.recent-section li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  font-size: 15px;
  color: #0f0e0e;
}
.recent-section li:last-child {
  border-bottom: none;
}
.date {
  color: #00998B;
  font-weight: 500;
}
.status {
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  margin-left: 4px;
  color: white;
  font-size: 13px;
}
.status.en attente { background: #ff9800; }
.status.confirmée { background: #00998B; }
.status.expediee { background: #3f51b5; }
.status.livree { background: #4caf50; }

/* --- DARK MODE --- */
@media (prefers-color-scheme: dark) {
  .admin-layout { background: #0f1720; }
  .dashboard-admin { color: #e6edf1; }
  .stat-card, .recent-section {
    background: #1c2733;
    box-shadow: 0 4px 10px rgba(0,0,0,0.6);
  }
  .stat-card .info p { color: #00c8b3; }
  .recent-section h3 { color: #00c8b3; }
  .recent-section li { border-bottom: 1px solid #333; color: #fff; }
}

/* --- RESPONSIVE --- */
@media (max-width: 1024px) {
  .dashboard-admin {
    padding: 20px;
  }
}
@media (max-width: 600px) {
  .stat-card {
    flex-direction: column;
    text-align: center;
  }
  .stat-card .icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
}

.chart-section {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 40px;
}
.chart-section h3 {
  margin-bottom: 15px;
  color: #00c8b3;
  font-weight: 600;
}
canvas {
  width: 100% !important;
  height: 300px !important;
}

/* --- MODE SOMBRE --- */
@media (prefers-color-scheme: dark) {
  .chart-section {
    background: #1c2733;
    color: #e6edf1;
  }
}

/* === RESPONSIVE MOBILE & TABLET === */
@media (max-width: 1024px) {
  .dashboard-admin {
    padding: 20px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .chart-section {
    padding: 20px;
  }
}

/* --- STYLE MOBILE AMÉLIORÉ (≤600px) --- */
@media (max-width: 600px) {

  /* Conteneur principal */
  .dashboard-admin {
    padding: 12px;
    background: #0d1117; /* douce transition entre sections */
  }

  /* Titre principal */
  .dashboard-admin h2 {
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
    color: #00c8b3;
  }

  /* Cartes de stats */
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .stat-card {
    background: #1c2733;
    border-radius: 10px;
    padding: 15px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .stat-card h3 {
    font-size: 14px;
    color: #00c8b3;
  }

  .stat-card p {
    font-size: 22px;
    font-weight: bold;
    color: #fff;
  }

  /* Graphique */
  .chart-section {
    background: #1c2733;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    margin-top: 20px;
  }

  .chart-section h3 {
    text-align: center;
    font-size: 15px;
    color: #00c8b3;
  }

  canvas {
    height: 220px !important;
  }

  /* Section activités récentes */
  .recent-section {
    background: #1c2733;
    border-radius: 10px;
    padding: 15px;
    margin-top: 20px;
  }

  .recent-section h3 {
    font-size: 15px;
    color: #00c8b3;
    text-align: center;
  }

  .recent-section li {
    font-size: 13px;
    color: #e6edf1;
    border-bottom: 1px solid #2a3645;
    padding: 8px 0;
  }
}

/* === NOTIFICATIONS === */
.notification-section {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
}

.notification-section h3 {
  margin-bottom: 15px;
  color: #00998B;
  font-size: 18px;
  font-weight: 600;
}

.notification-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.notif-item {
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 10px;
  transition: background 0.3s;
}

.notif-item:hover {
  background: #eef9f8;
}

.notif-time {
  font-size: 12px;
  color: #888;
  margin-bottom: 4px;
}

.notif-text {
  font-size: 14px;
  color: #222;
}

.empty-msg {
  color: #888;
  font-size: 14px;
  text-align: center;
}

/* --- DARK MODE --- */
@media (prefers-color-scheme: dark) {
  .notification-section {
    background: #1c2733;
  }
  .notif-item {
    background: #263342;
  }
  .notif-item:hover {
    background: #2e3f52;
  }
  .notif-text {
    color: #e6edf1;
  }
  .notif-time {
    color: #8b97a3;
  }
}

@media (max-width: 600px) {
  .notification-section {
    padding: 15px;
  }

  .notif-item {
    padding: 10px;
    font-size: 13px;
  }
}

/* === TOAST NOTIFICATIONS === */
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.toast {
  display: flex;
  align-items: center;
  background: #1c2733;
  color: #fff;
  padding: 12px 18px;
  border-radius: 8px;
  min-width: 250px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  animation: slideIn 0.4s ease, fadeOut 0.5s ease 3.5s forwards;
}

.toast .icon {
  font-size: 22px;
  margin-right: 10px;
}

.toast-content {
  display: flex;
  flex-direction: column;
}

.toast-message {
  font-size: 15px;
  font-weight: 600;
}

.toast small {
  font-size: 12px;
  opacity: 0.8;
}

/* Types de toasts */
.toast.info {
  background: linear-gradient(135deg, #00998b, #007b7a);
}
.toast.success {
  background: linear-gradient(135deg, #28a745, #1f7a34);
}
.toast.error {
  background: linear-gradient(135deg, #e53935, #b71c1c);
}

/* Animation slide */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fadeOut {
  to {
    opacity: 0;
    transform: translateX(50px);
  }
}

/* Transition group */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(40px);
}

</style>
